import { Tab, Tabs } from '@mui/material';
import { NavLink, useLocation } from 'react-router-dom';

const TabsNavigate = () => {
  const location = useLocation();

  const tabsInfo = [
    { label: 'G. de artículos', path: '/master/articulos' },
    { label: 'G. de Solicitudes', path: '/master/orders' },
    { label: 'G. de usuarios', path: '/master/users' },
    { label: 'G. de centros', path: '/master/tienda' },
    { label: 'G. de clusters', path: '/master/clusters' },
    { label: 'G. de categorias', path: '/master/categorias' },
    { label: 'G. de materiales', path: '/master/materiales' },
    { label: 'G. de proveedores', path: '/master/proveedores' },
    { label: 'Estadísticas', path: '/master/stats' },
    { label: 'G. de archivos', path: '/master/archivos' },
  ];

  const currentTabIndex = tabsInfo.findIndex((tab) => location.pathname.includes(tab.path));

  return (
    <Tabs value={currentTabIndex}>
      {tabsInfo.map((tab, index) => (
        <NavLink key={index} className={'tabs-navigate-admin'} to={tab.path}>
          <Tab label={tab.label} />
        </NavLink>
      ))}
    </Tabs>
  );
};

export default TabsNavigate;
